import Icons from "@/src/components/Icons";
import OrdersHeader from "../Orders/OrdersHeader";
import HelpMoldal from "./HelpMoldal";
import { useEffect, useState } from "react";
import ShippingItemModal from "./ShippingItemModal";
import { shippingApi } from "@/src/utils/api/shipping";
import moment from "jalali-moment";
import ShippingItem from "./ShippingItem";
function Shipping() {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalItem, setShowModalItem] = useState<boolean>(false);
  const [dataModelItem, setModaDatalItem] = useState<any>(null);
  const [data, setData] = useState<any>([]);
  useEffect(() => {
    const today = moment().locale("fa");
    const startOfToday = today.startOf("day");
    const endOfToday = today.endOf("day");
    shippingApi
      .list(startOfToday.valueOf(), endOfToday.valueOf())
      .then((res) => {
        setData(res.data);
      });
  }, []);
  return (
    <div>
      <OrdersHeader />
      <h4
        className="flex gap-2 items-center cursor-pointer"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <Icons name="info" fill="none" size={25} />{" "}
        <span className="text-xl font-bold">راهنما</span>
      </h4>
      <HelpMoldal open={showModal} close={() => setShowModal(false)} />
      <ShippingItemModal
        open={showModalItem}
        data={dataModelItem}
        close={() => setShowModalItem(false)}
      />
      <div className="mt-4 flex flex-col gap-4">
        {data && data.length > 0 ? (
          data.map((item: any) => {
            return (
              <ShippingItem
                data={item}
                onClick={() => {
                  if (
                    item.status &&
                    item.status.code != "CANCELLED" 
                  ) {
                    setModaDatalItem(item);
                    setShowModalItem(true);
                  }
                }}
              />
            );
          })
        ) : (
          <>
            <div className="items  mt-2 flex flex-col justify-center items-center">
              <Icons name="undefinedIcon" size={200} fill="none" />
              <h6 className="text-xl font-bold text-gray-200-mmpz">
                ارسالی برای شما رزرو نشده است.
              </h6>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Shipping;
